import styled from "styled-components";

const ease = "cubic-bezier(0.2, 0.7, 0.2, 1)";

export const CardLink = styled.a`
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  color: inherit;
  text-decoration: none;
  cursor: pointer;
  &:focus-visible {
    outline: 3px solid #02c5ff;
    outline-offset: 4px;
  }
  @media (prefers-reduced-motion: reduce) {
    &,
    & * {
      transition: none !important;
    }
  }
`;

// Fixed 16:9 frame, so cards line up whatever the uploaded image size.
export const Media = styled.div`
  position: relative;
  overflow: hidden;
  aspect-ratio: 16 / 9;
  background: #e6ecf8;
  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.8s ${ease};
  }
  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(to top, rgba(4, 61, 186, 0.45), rgba(4, 61, 186, 0) 55%);
    opacity: 0;
    transition: opacity 0.4s ease;
  }
  ${CardLink}:hover & img,
  ${CardLink}:focus-visible & img {
    transform: scale(1.06);
  }
  ${CardLink}:hover &::after,
  ${CardLink}:focus-visible &::after {
    opacity: 1;
  }
  @media (max-width: 768px) {
    margin-top: 25px;
  }
`;

export const Details = styled.div`
  display: flex;
`;

export const DateBadge = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 150px;
  margin-top: -32px;
  padding: 22px 24px;
  background: #0043ff;
  color: #fafbff;
  transition: transform 0.45s ${ease}, background-color 0.3s ease;
  ${CardLink}:hover &,
  ${CardLink}:focus-visible & {
    transform: translateY(-8px);
    background-color: #043dba;
  }
  @media (max-width: 768px) {
    position: absolute;
    top: 25px;
    left: 0;
    min-width: auto;
    margin-top: 0;
    padding: 8px 12px;
  }
`;

export const Day = styled.span`
  font-size: 3.2rem;
  font-weight: 500;
  line-height: 1;
  @media (max-width: 768px) {
    font-size: 1.9rem;
  }
`;

export const MonthYear = styled.span`
  margin-top: 8px;
  font-size: 1.35rem;
  font-weight: 300;
  text-transform: capitalize;
  white-space: nowrap;
  @media (max-width: 768px) {
    margin-top: 2px;
    font-size: 0.95rem;
  }
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  gap: 14px;
  min-width: 0;
  padding: 18px 0 0 22px;
  @media (max-width: 768px) {
    padding: 12px 0 0;
  }
`;

export const Title = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: #092063;
  font-size: 1.5rem;
  font-weight: 500;
  line-height: 1.35;
  min-height: calc(3 * 1.35em);
  transition: color 0.3s ease;
  ${CardLink}:hover &,
  ${CardLink}:focus-visible & {
    color: #0043ff;
  }
  @media (max-width: 768px) {
    min-height: 0;
    font-size: 1.18rem;
    line-height: 1.6rem;
  }
`;

export const ReadMore = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #0043ff;
  font-size: 1.15rem;
  font-weight: 500;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  svg {
    transition: transform 0.35s ${ease};
  }
  ${CardLink}:hover & svg,
  ${CardLink}:focus-visible & svg {
    transform: translateX(6px);
  }
`;
